import HttpService from './baseHttp'

// 承运商账号列表
export const HttpCarrierAccountList = (data = {}) => HttpService.get("/api/v2/carrierGroup/findByPage", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 详情
export const HttpGetCarrierAccountDetail = (data = {}) => HttpService.get("/api/v2/carrierGroup/detail", { params: data })
// 启用、失效
export const HttpActiveCarrierAccount = (data = {}) => HttpService.post("/api/v2/carrierGroup/active", data);
// 添加账号
export const HttpAddAccount = (data = {}) => HttpService.post("/api/v2/carrierGroup/addAccount", data);
// 添加、编辑承运商账号分组
export const HttpUpdateAccountGroup = (data = {}) => HttpService.post("/api/v2/carrierGroup/create", data);
// 承运商shipping账号列表
export const HttpCarrierShippingAccountList = (data = {}) => HttpService.get("/api/v2/carrierShipping/findByPage", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// shipping单条查询
export const HttpGetShippingDetail = (data = {}) => HttpService.get("/api/v2/carrierShipping/getById", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// shipping创建、编辑
export const HttpUpdateShippingAccount = (data = {}) => HttpService.post("/api/v2/carrierShipping/create", data);
// 承运商billing账号列表
export const HttpCarrierBillingAccountList = (data = {}) => HttpService.get("/api/v2/carrierBilling/findByPage", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 获取承运商分组
export const HttpGetCarrierGroup = (data = {}) => HttpService.get("/api/v2/carrierGroup/findByContextId", { params: data });
// 获取账号
export const HttpGetBillingAccount = (data = {}) => HttpService.get("/api/v2/carrierBilling/findByCarrierGroupId", { params: data });
// billing单条查询
export const HttpGetBillingDetail = (data = {}) => HttpService.get("/api/v2/carrierBilling/getById", { params: data });
// billing编辑
export const HttpUpdateBillAccountDetail = (data = {}) => HttpService.post("/api/v2/carrierBilling/create", data,{ headers: { 'Content-Type': 'application/json' } });
// 承运商黑名单列表
export const HttpGetBlackList = (data = {}) => HttpService.get("/api/v2/carrierBlackList/findByPage", { params: data });
// 黑名单详情
export const HttpGetBlackDetail = (data = {}) => HttpService.get("/api/v2/carrierBlackList/getById", { params: data });
// 黑名单创建、编辑
export const HttpUpdateBlackDetail = (data = {}) => HttpService.post("/api/v2/carrierBlackList/create", data);
// 黑名单失效、启用
export const HttpBlackListActive = (data = {}) => HttpService.post("/api/v2/carrierBlackList/active", data);
// 承运商服务列表
export const HttpGetCarrierServiceList = (data = {}) => HttpService.get("/api/v2/carrierVolumeWeight/findByPage", { params: data });
// 承运商服务详情
export const HttpGetCarrierServiceDetail = (data = {}) => HttpService.get("/api/v2/carrierVolumeWeight/getById", { params: data });
// 承运商服务编辑
export const HttpUpdateCarrierService = (data = {}) => HttpService.post("/api/v2/carrierVolumeWeight/create", data);
// 根据分组查询承运商服务
export const HttpGetCarrierServiceByGroupId = (data = {}) => HttpService.get("/api/v2/carrierVolumeWeight/findByCarrierGroupId", { params: data });
// 查询所有承运服务
export const HttpGetAllCarrierService = (data = {}) => HttpService.get("/api/v2/carrierVolumeWeight/findDeliveryCarrier", { params: data });
// 根据客户id查询仓库
export const HttpGetWarehouseByContextId = (data = {}) => HttpService.get("/api/v2/organizationWarehouse/findOrgWarehousesByOrgId", { params: data });
// 根据客户或者管理组织获得相关分组数据
export const HttpGetCarrierGroupByOrg = (data = {}) => HttpService.get("/api/v2/carrierGroupOrg/findByFilter", { params: data });

// 物流产品服务---根据物流产品服务获取物流服务代码
export const HttpGetCarrierCode = (data = {}) => HttpService.get("/api/v2/carrierVolumeWeight/findCode", { params: data });


//所有承运商
export const HttpCarrierAllList = (data = {}) => HttpService.get('/api/v2/systemCarrier/findAllActive', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })
// 查询承运商分组
export const HttpGetCarrierGroupByCarrierId = (data = {}) => HttpService.get("/api/v2/carrierBlackList/findByCarrierId", { params: data });
// 组织下对应可用仓库
export const HttpOrgServiceWarehouseList = (data = {}) => HttpService.get('/api/v2/warehouse/findAllByOrgId', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })
//获取当前管理组织管理及所选客户有权限的组织仓
export const HttpHostAndCustomerWarehouse = (data = {}) => HttpService.post("/api/v2/customerRate/getHostAndCustomerWarehouse", data, { baseURL: process.env.VUE_APP_APIURL_FBB});
// 获取仓库
export const HttpGetWarehouseList = (data = {}) => HttpService.get("/api/v2/organizationWarehouse/findAllByHostOrgId", { params: data }, { baseURL: process.env.VUE_APP_APIURL_FBB});
// 物流商失效、启用
export const HttpActiveCarrier = (data = {}) => HttpService.post("/api/v2/carrierGroup/groupActive", data);
// 编辑服务配置获取数据
export const HttpGetEditServiceData = (data = {}) => HttpService.get("api/v2/carrierGroup/carrierService", { params: data });
// 编辑服务配置
export const HttpEditServiceData = (data = {}) => HttpService.post("/api/v2/carrierGroup/editService", data, { headers: { 'Content-Type': 'application/json' } });



// 仓库承运商
// 列表、查看、编辑/创建、启用/失效
export const HttpWarehouseCarrierList = (data = {}) => HttpService.get("/api/v2/WarehouseCarrierService/findByPageNew", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
export const HttpWarehouseCarrierOne = (data = {}) => HttpService.get("/api/v2/WarehouseCarrierService/detailNew", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
export const HttpSaveWarehouseCarrier = (data = {}) => HttpService.post("/api/v2/WarehouseCarrierService/create", data);
export const HttpActiveWarehouseCarrier = (data = {}) => HttpService.post("/api/v2/WarehouseCarrierService/activeEdit", data);


// 物流服务测算
// 列表、又物流服务、编辑/创建、测算
export const HttpLogiticMeasureList = (data = {}) => HttpService.get("/api/v2/carrierCalculate/findByPage", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
export const HttpLogiticServiceOne = (data = {}) => HttpService.get("/api/v2/carrierCalculate/findByContextId", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
export const HttpSaveLogiticMeasure = (data = {}) => HttpService.post("/api/v2/carrierCalculate/create", data);
export const HttpActiveLogiticMeasure = (data = {}) => HttpService.post("/api/v2/carrierCalculate/active", data);


// 查询黑名单和仓库承运商的物流服务
export const HttpOtherLogiServiceList = (data = {}) => HttpService.get("/api/v2/carrierVolumeWeight/findByGroupId", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 仓库承运尚带有卡车的物流服务/物流产品（有效、全部）
export const HttpTruckServiceList = (data = {}) => HttpService.get("/api/v2/carrierVolumeWeight/findAllManageByContext", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
export const HttpTruckLogAllList = (data = {}) => HttpService.get("/api/v2/carrierVolumeWeight/findAllByContextIdAndTruck", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
export const HttpAllTruckLogProdList = (data = {}) => HttpService.get("/api/v2/carrierGroup/findAllByContextIdAndTruck", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });

// 操作历史
export const HttpCarrierGroupLog = (data = {}) => HttpService.get("/api/v2/carrierGroup/detail", { params: data });
export const HttpCarrierProductLog = (data = {}) => HttpService.get("/api/v2/carrierVolumeWeight/detail", { params: data });
export const HttpBillingAccountLog = (data = {}) => HttpService.get("/api/v2/carrierBilling/detail", { params: data });
export const HttpBlackAccountLog = (data = {}) => HttpService.get("/api/v2/carrierBlackList/detail", { params: data });
export const HttpLogisticMeasureLog = (data = {}) => HttpService.get("/api/v2/carrierCalculate/detail", { params: data });
export const HttpWarehouseCarrierLog = (data = {}) => HttpService.get("/api/v2/WarehouseCarrierService/detailNew", { params: data });

export const HttpDownloadMaterialTemplate = (data = {}) => HttpService.post("/api/v2/carrierAddonRule/importTemplate", data);
